import './vendor/outdatedbrowser/outdatedbrowser.js';
import './vendor/slick/slick.js';
import { getBreakpoint } from 'Utils/breakpoints.js';

import './blocks/image-slider.js';
import './blocks/case-study-info.js';
import './blocks/timeline.js';

$(function () {
    // outdatedBrowser({
    //     bgColor: '#f25648',
    //     color: '#ffffff',
    //     lowerThan: 'borderImage'
    // });

    $('.navigation-toggle').on('click', function(e) {
        e.preventDefault();
        $('body').toggleClass('menu-open');
        $('.popup-search__container').removeClass('active');
    });

    $('.popup-search-bar input').on('focus', function(e) {
        e.preventDefault();
        popupSearch();
    });

    $('.popup-search-bar button').on('click', function(e) {
        e.preventDefault();
        popupSearch();
    });

    $('.popup-search__close').on('click', function(e) {
        e.preventDefault();
        popupSearch();
    });

    $('.skip-link').on('click', function(e) {
        e.preventDefault();
        const target = $(e.currentTarget).attr('href');
        $('html, body').animate({
            scrollTop: $(target).offset().top
        }, 1200);
    });

    const hash = $(location).attr('hash');
    if (hash !== '') {
        $(window).scrollTop(0);
        setTimeout(function() {
            $('html, body').animate({
                scrollTop: $(hash).offset().top
            }, 1200);
        }, 500);
        return;
    }

    // make product tables responsive
    $('.product__body table').wrapAll('<div class="table-responsive" />');
});

$(window).on('load', function() {
    $('body').addClass('loaded');

    const scrollDistance = $(window).scrollTop();

    // menu background toggle
    if (scrollDistance > 50) {
        $('body').addClass('scrolled');
    } else {
        $('body').removeClass('scrolled');
    }

    $('.page-list__blog--slider').slick({
        rows: 0,
        mobileFirst: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 8000,
        arrows: false,
        dots: true,
        infinite: true,
        slide: '.page-list__blog--article',
        responsive: [
            {
                breakpoint: getBreakpoint('lg'),
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    dots: false
                }
            }
        ]
    });
});

// window scroll functions
$(window).on('scroll', function () {
    const scrollDistance = $(window).scrollTop();

    // menu background toggle
    if (scrollDistance > 50) {
        $('body').addClass('scrolled');
    } else {
        $('body').removeClass('scrolled');
    }
});

function popupSearch() {
    $('.popup-search-bar input').trigger('blur');
    $('.popup-search-bar button').trigger('blur');
    $('.popup-search__container').toggleClass('active');
}
